function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import claimService from '@rd-web-markets/shared/dist/services/claim/claim.service';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import React, { useState } from 'react';
export function ClaimFinancialField(_ref) {
  let {
    claim,
    setClaim,
    fieldName,
    disabled,
    onClaimUpdateSuccess,
    size = 'sm'
  } = _ref;
  const [stateClaim, setStateClaim] = useState(claim);
  const updateClaim = claimService.useUpdate({
    claimId: claim.id,
    setClaim,
    onSuccess: onClaimUpdateSuccess
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: _ref2 => {
      let {
        target: {
          value
        }
      } = _ref2;
      return setClaim(_objectSpread(_objectSpread({}, claim), {}, {
        [fieldName]: value
      }));
    },
    onBlur: () => updateClaim(_objectSpread({}, claim)),
    disabled: claim.financials_locked || disabled,
    name: fieldName,
    size: size,
    style: {
      textAlign: 'right'
    },
    object: _objectSpread(_objectSpread({}, claim), {}, {
      claim: _objectSpread({}, claim)
    })
  }));
}